// @flow
import type {Node} from 'react'
import React, {Fragment} from 'react'
import {graphql, useFragment} from 'react-relay'

import SectionItem from 'components/SideBar/ui/SectionItem'
import ItemsSection from 'components/SideBar/ui/ItemsSection'
import type {
  YourOrganizationSection_organization$key as OrganizationKey,
} from './__generated__/YourOrganizationSection_organization.graphql'
import type {
  YourOrganizationSection_viewer$key as ViewerKey,
} from './__generated__/YourOrganizationSection_viewer.graphql'

type Props = $ReadOnly<{
  organization: OrganizationKey,
  viewer: ViewerKey,
}>

const organizationFragment = graphql`
  fragment YourOrganizationSection_organization on Organization {
    constitutionLabel
    viewerCanViewConstitution
  }
`

const viewerFragment = graphql`
  fragment YourOrganizationSection_viewer on Person {
    routes {
      constitutionPath
      membershipListsPath
      printableGovernancePath
      searchProjectsPath
    }
  }
`

function YourOrganizationSection({
  organization: organizationKey,
  viewer: viewerKey,
}: Props): Node {
  const organization = useFragment(organizationFragment, organizationKey)
  const routes = useFragment(viewerFragment, viewerKey).routes
  const reportsPath = routes.printableGovernancePath

  return (
    <ItemsSection
      collapsibleSection
      id="your-organization-section"
      sectionName="your_organization-sections"
      title={I18n.t('side_nav.your_organization.title')}
      renderChildren={() => (
        <Fragment>
          {organization.viewerCanViewConstitution && (
            <SectionItem
              title={organization.constitutionLabel}
              href={routes.constitutionPath}
            />
          )}
          <SectionItem
            title={I18n.t('side_nav.reports_section.membership_lists')}
            href={routes.membershipListsPath}
          />
          <SectionItem
            title={I18n.t('reports.title')}
            href={reportsPath}
          />
        </Fragment>
      )}
    />
  )
}

export default YourOrganizationSection
